import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Footer from './common-components/Footer';
import NavBar from './common-components/NavBar';
import Home from './pages/Home';
import Admin from './pages/Admin';
import ReviewQueue from './pages/ReviewQueue';
import UrlStatus from './pages/UrlStatus';
import NotFound from './pages/NotFound';
import Publish from './pages/ReviewQueue/components/Publish';
import Login from './pages/Login';
import Logout from './pages/Logout';
import { ProvideAuth, PrivateRoute } from './pages/Login/useAuth';
import AzureLogin from './pages/Login/components/AzureLogin';
import './App.css';


class App extends React.Component {
  render() {
    return (
      <>
        <ProvideAuth>
          <NavBar />
          <div className='app-container'>
            <Switch>
              <Redirect exact from='/' to='/home' />
              <Route exact path='/login' component={Login} />
              <Route exact path='/Login/azuread-tenant-oauth2' component={AzureLogin} />
              <PrivateRoute exact path='/home'><Home /></PrivateRoute>
              <PrivateRoute exact path='/logout'><Logout /></PrivateRoute>
              <PrivateRoute exact path='/admin'><Admin /></PrivateRoute>
              <PrivateRoute exact path='/review_queue'><ReviewQueue /></PrivateRoute>
              <PrivateRoute exact path='/url_status'><UrlStatus /></PrivateRoute>
              <PrivateRoute path='/review_queue/uridb_published'><Publish /></PrivateRoute>
              <Route component={NotFound} />
            </Switch>
          </div>
          <Footer />
        </ProvideAuth>
      </>
    );
  }
}

export default App;
